import { useTranslate } from '@tolgee/react';
import { SearchResultWithAllFragment } from '@amf/shared/types/graphql';
import Loader from '@amf/shared/components/utils/Loader';
import Empty from '@amf/shared/components/utils/Empty';

import { SearchScope } from './hooks/useAdvancedSearch';
import NewsResult from './results/NewsResult';
import PlayerResult from './results/PlayerResult';
import LeagueResult from './results/LeagueResult';
import ClubResult from './results/ClubResult';
import TeamResult from './results/TeamResult';
import GroundResult from './results/GroundResult';

type Props = {
  results: SearchResultWithAllFragment[];
  loading: boolean;
  prefixes: {
    news: string;
    player: string;
    league: string;
    club: string;
    team: string;
    ground: string;
  };
};

function AdvancedSearchResults({ results, loading, prefixes }: Props) {
  const { t } = useTranslate();
  if (loading) return <Loader size='normal'>{t('loading')}</Loader>;
  if (results.length === 0) return <Empty size='normal'>{t('search.empty')}</Empty>;
  return (
    <div className='AdvancedSearch__resultList'>
      <h2>{t('search.results')}</h2>
      {results.map(item => {
        if (item.type === SearchScope.NEWS)
          return <NewsResult key={item.id} item={item} prefixes={prefixes} />;
        if (item.type === SearchScope.PLAYERS)
          return <PlayerResult key={item.id} item={item} prefixes={prefixes} />;
        if (item.type === SearchScope.LEAGUES)
          return <LeagueResult key={item.id} item={item} prefixes={prefixes} />;
        if (item.type === SearchScope.CLUBS)
          return <ClubResult key={item.id} item={item} prefixes={prefixes} />;
        if (item.type === SearchScope.TEAMS)
          return <TeamResult key={item.id} item={item} prefixes={prefixes} />;
        if (item.type === SearchScope.GROUNDS)
          return <GroundResult key={item.id} item={item} prefixes={prefixes} />;
        return null;
      })}
    </div>
  );
}

export default AdvancedSearchResults;
